// stage link
// export const ApiLink="https://api-pwrsteer.mobikasa.net/api/"
// prod(live) link
export const ApiLink="https://newdb.pwrsteer.com/api/"
  
// export const ApiLink ="https://68c48cbe8a86.ngrok-free.app/api/"

// new dynamic link
// export const ApiLink = process.env.REACT_APP_API_BASE_URL;
